import { z } from "zod";

export const rowAuditSchema = z.object({
  createdOn: z.coerce.date(),
  createdBy: z.string().or(z.null()),
});

export const mutableRowAuditSchema = rowAuditSchema.extend({
  updatedOn: z.coerce.date(),
  updatedBy: z.string().or(z.null()),
});

export type RowAudit = z.infer<typeof rowAuditSchema>;

export type MutableRowAudit = z.infer<typeof mutableRowAuditSchema>;
